import script from "./AnalyzePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyzePage.vue?vue&type=script&setup=true&lang=js"

import "./AnalyzePage.vue?vue&type=style&index=0&id=2266f8c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2266f8c8"]])

export default __exports__